export const IS_ZIPPAY_ENABLED = (region: any) => {
    const enabledRegions = ['au'];
    if (enabledRegions.includes(region)) {
        return true;
    }
    
    return false;
}